import {
    aggregationFn_sum,
    aggregationFn_uniqueCount,
    columnFacetingFeature,
    columnFilteringFeature,
    columnGroupingFeature,
    columnResizingFeature,
    columnSizingFeature,
    columnVisibilityFeature,
    constructAggregationFn,
    createColumnHelper,
    createExpandedRowModel,
    createFacetedUniqueValues,
    createFilteredRowModel,
    createGroupedRowModel,
    createPaginatedRowModel,
    createSortedRowModel,
    filterFn_equals,
    filterFn_includesString,
    rowAggregationFeature,
    rowExpandingFeature,
    rowPaginationFeature,
    rowSelectionFeature,
    rowSortingFeature,
    tableFeatures
} from "@tanstack/react-table";
import type { ColumnDef, RowData } from "@tanstack/react-table";

import {
    arrIncludes,
    includesValueFormat,
    notEquals,
    notZero,
    numberEqualOrGreaterThan,
    startsWith,
    zeroFilter
} from "./ReactTableFilters";
import type { FilteredColumnDef } from "./ReactTableFilters";

export const reactTableFeatures = tableFeatures({
    columnVisibilityFeature,
    columnSizingFeature,
    columnResizingFeature,
    columnFilteringFeature,
    columnFacetingFeature,
    rowSortingFeature,
    rowPaginationFeature,
    rowSelectionFeature,
    filteredRowModel: createFilteredRowModel(),
    sortedRowModel: createSortedRowModel(),
    paginatedRowModel: createPaginatedRowModel(),
    facetedUniqueValues: createFacetedUniqueValues(),
    filterFns: {
        includesString: filterFn_includesString,
        equals: filterFn_equals,
        arrIncludes,
        startsWith,
        notEquals,
        includesValueFormat,
        numberEqualOrGreaterThan,
        notZero,
        zeroFilter
    }
});

export const tableGrouperFeatures = tableFeatures({
    columnVisibilityFeature,
    columnSizingFeature,
    columnGroupingFeature,
    rowExpandingFeature,
    rowSortingFeature,
    rowAggregationFeature,
    groupedRowModel: createGroupedRowModel(),
    expandedRowModel: createExpandedRowModel(),
    sortedRowModel: createSortedRowModel(),
    aggregationFns: {
        sum: aggregationFn_sum,
        uniqueCount: aggregationFn_uniqueCount
    }
});

export function createReactTableColumnHelper<TData extends RowData>() {
    return createColumnHelper<typeof reactTableFeatures, TData>() as any;
}

export type ReactTableColumnDef<TData extends RowData, TValue = unknown> = ColumnDef<typeof reactTableFeatures, TData, TValue> &
    FilteredColumnDef;

export const firstChildAggregation = constructAggregationFn({
    aggregate: ({ rows, getValue }) => (rows[0] ? getValue(rows[0]) : undefined),
    merge: ({ subRowResults }) => subRowResults[0]
});
